import DefaultValidator from './default-validator';

/**
 * Class to validate resource actions (add, read, delete.. etc)
 * @extends DefaultValidator
 */
export default class ActionValidator extends DefaultValidator {
    /**
     * Creates the proper validator based on instance state
     * @param {string} unknownProperty
     * @return {DefaultValidator}
     */
    $validate(unknownProperty) {
        // Set $parentProperty to $property will allow validation chain
        // Auth.users.add.read.delete.edit.isAllowed
        return this.$addValidator(unknownProperty,
            ActionValidator, {$property: this.$parentProperty});
    }

    /**
     * Checks if the previous validation pass and there is
     * permission for this action.
     * @return {boolean}
     */
    get isAllowed() {
        if (!this.$wasAllowed) { return false; }
        const actions = this.$permissions[this.$parentProperty];
        return !!actions && actions.includes(this.$property);
    }
}
